import './Button.styles.css';

function Button({text,type,handleClick,backgroundColor
}){
    return <button type={type} className="button" onClick={()=> handleClick()} style={{backgroundColor:backgroundColor}}>{text}</button>

}
export default Button;